// imports
import Link from 'next/link';
import { useAtom } from 'jotai';

// lib files
import { searchFiltersAtom } from '@/lib/atoms/search-filters';
import { ShowRowContent, ShowOrFranchiseEnum } from '@/lib/types/api/show-data';
import { Franchise } from '@/lib/types/api/franchise-data';

// components
import ShowRow from '@/components/ShowRow/ShowRow';

// styles
import styles from './SearchShowResults.module.scss';
interface SearchShowResultsProps {
  searchShowResults: {
    content: Array<ShowRowContent | Franchise>;
  };
}
const SearchShowResults = (props: SearchShowResultsProps) => {
  const {
    searchShowResults
  } = props;
  const [searchFilters] = useAtom(searchFiltersAtom);

  // falling back to an empty string mostly for storybook
  const query = searchFilters.query || '';
  const {
    content: shows
  } = searchShowResults;
  let showsToDisplay = shows;
  const areAnyShowsFranchise = shows.some(show => show.item_type === ShowOrFranchiseEnum.Franchise);

  // if any of the results are a franchise, only show franchises
  if (areAnyShowsFranchise) {
    showsToDisplay = shows.filter(show => show.item_type === ShowOrFranchiseEnum.Franchise);
  }
  let titleText;
  switch (true) {
    case areAnyShowsFranchise:
      titleText = 'Franchise';
      break;
    case shows.length > 1:
      titleText = 'Shows';
      break;
    default:
      titleText = 'Show';
      break;
  }
  const overRideOptions = {
    perPage: 3,
    gap: '8px',
    breakpoints: {
      600: {
        perPage: 4
      },
      1024: {
        gap: '12px',
        perPage: 5
      },
      1440: {
        gap: '16px',
        perPage: 6
      }
    }
  };
  return <div className={styles.search_show_results} data-sentry-component="SearchShowResults" data-sentry-source-file="SearchShowResults.tsx">
      <h2 className={styles.search_show_results_title}>
        <Link href={`/shows?search=${query}`} data-sentry-element="Link" data-sentry-source-file="SearchShowResults.tsx">
          {titleText}
        </Link>
      </h2>

      <ShowRow shows={showsToDisplay} className={styles.search_results_show_row} overRideOptions={overRideOptions} data-sentry-element="ShowRow" data-sentry-source-file="SearchShowResults.tsx" />
    </div>;
};
export default SearchShowResults;